import { createContext } from 'react';

const defaultValue = {};

export const SubscriptionPlansContext = createContext(defaultValue);
